var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "info-item",
        {
          attrs: {
            label: _vm.resource("DmVisualizer_ChangeInfo_OpeningHours"),
            isEnabled: _vm.isEnabled
          },
          on: {
            "set-enabled": function($event) {
              return _vm.$emit("set-enabled", $event)
            }
          }
        },
        [
          _vm.daysReady
            ? _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  _vm._l(_vm.daysLeft, function(day) {
                    return _c("info-text-input", {
                      key: day.key,
                      attrs: {
                        label: day.key,
                        placeholder: day.placeholder,
                        isEnabled: _vm.isEnabled,
                        value: day.value
                      },
                      on: {
                        input: function($event) {
                          return _vm.emitFieldUpdate(day.name, $event)
                        }
                      }
                    })
                  }),
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  _vm._l(_vm.daysRight, function(day) {
                    return _c("info-text-input", {
                      key: day.key,
                      attrs: {
                        label: day.key,
                        placeholder: day.placeholder,
                        isEnabled: _vm.isEnabled,
                        "": day.value
                      },
                      on: {
                        input: function($event) {
                          return _vm.emitFieldUpdate(day.name, $event)
                        }
                      }
                    })
                  }),
                  1
                )
              ])
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }